import { useEffect } from 'react';
import axios from 'axios';
import RefreshIcon from '@mui/icons-material/Refresh';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import logo from '../../assets/images/logo-1313mart.png';

// Simple header shown only on /admin/* pages, replacing the full customer-
// facing Header (announcement bar, search, cart, etc.) which doesn't belong
// in the admin panel. Kept intentionally minimal — just branding plus two
// utility buttons.
const AdminHeader = () => {

    // Applies the same admin-uploaded favicon as the customer-facing Header,
    // so it's correct even when someone lands directly on an /admin/* page
    // without ever loading the public site first in that session.
    useEffect(() => {
        const applyFavicon = async () => {
            try {
                const { data } = await axios.get('/api/v1/header-settings');
                if (data.settings.favicon?.url) {
                    let link = document.querySelector("link[rel~='icon']");
                    if (!link) {
                        link = document.createElement('link');
                        link.rel = 'icon';
                        document.head.appendChild(link);
                    }
                    link.href = data.settings.favicon.url;
                }
            } catch (error) {
                console.error('Failed to load favicon setting', error);
            }
        };
        applyFavicon();
    }, []);

    const handleVisitSite = () => {
        window.open('/', '_blank');
    };

    const handleRefresh = () => {
        // A webpage can't trigger a true browser "hard refresh" (that's a
        // browser-chrome-level action). This clears any Cache Storage
        // entries first (used by service workers, if the app ever adds
        // one) and then reloads, which is the closest equivalent available
        // from code.
        if ('caches' in window) {
            caches.keys().then((names) => {
                names.forEach((name) => caches.delete(name));
            });
        }
        window.location.reload();
    };

    return (
        <header className="fixed top-0 left-0 w-full h-16 z-20 bg-gray-900 text-white flex items-center justify-between px-4 sm:px-6 shadow">
            <div className="flex items-center gap-2">
                <img draggable="false" src={logo} alt="1313 Mart" className="h-8 w-8 object-contain" />
                <span className="font-semibold text-sm sm:text-base">1313 Mart Admin</span>
            </div>
            <div className="flex items-center gap-2 sm:gap-3">
                <button onClick={handleVisitSite} className="flex items-center gap-1.5 text-xs sm:text-sm bg-gray-700 hover:bg-gray-600 px-3 py-2 rounded shadow">
                    <OpenInNewIcon sx={{ fontSize: "16px" }} />
                    <span className="hidden sm:inline">Visit Site</span>
                </button>
                <button onClick={handleRefresh} className="flex items-center gap-1.5 text-xs sm:text-sm bg-primary-orange hover:opacity-90 px-3 py-2 rounded shadow">
                    <RefreshIcon sx={{ fontSize: "16px" }} />
                    <span className="hidden sm:inline">Refresh</span>
                </button>
            </div>
        </header>
    );
};

export default AdminHeader;